import { Box, ListItem, styled } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { isMobile } from 'react-device-detect';

export const Container = styled(Box)(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',

  gridTemplateColumns:
    'minmax(250px, 3fr) minmax(300px, 3fr) minmax(400px, 5fr)',
  [`@container (max-width: ${theme.breakpoints.values.desktop}px)`]: {
    gridTemplateColumns:
      'minmax(250px, 3fr) minmax(100px, 2fr) minmax(400px, 5fr)',
  },
  [`@container (max-width: ${theme.breakpoints.values.md}px)`]: {
    gridTemplateColumns: 'minmax(250px, 4fr) minmax(100px, 5fr)',
  },
  [`@container (max-width: ${theme.breakpoints.values.sm}px)`]: {
    gridTemplateColumns: 'minmax(24px, 2fr) minmax(80px, 1fr)',
  },
  [`@container (max-width: 200px)`]: {
    gridTemplateColumns: 'minmax(20px, 4fr) minmax(40px, 1fr)',
  },
}));

export const TagsContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(100px, 1fr) minmax(100px, 1fr)',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  marginRight: theme.spacing(1),
  alignItems: 'center',

  [`@container (max-width: ${theme.breakpoints.values.desktop}px)`]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    display: 'flex',
  },
  [`@container (max-width: ${theme.breakpoints.values.md}px)`]: {
    display: 'none',
  },
}));

export const DurationContainer = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(4),
  color: theme.palette.text.secondary,
  paddingTop: theme.spacing(0.2),
  whiteSpace: 'nowrap',
  flexShrink: 0,
  display: 'flex',
  [`@container (max-width: ${theme.breakpoints.values.md}px)`]: {
    marginRight: theme.spacing(1),
  },
  [`@container (max-width: 200px)`]: {
    display: 'none',
  },
}));

export const WaveformContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: 400,
  flexShrink: 0,
  paddingTop: theme.spacing(0.8),
  // The width of the waveform is currently set based on developer observations
  // and should be adjusted once we create our own waveform generator
  width: '50%',

  [`@container (max-width: ${theme.breakpoints.values.desktop}px)`]: {
    width: '30%',
  },
  [`@container (max-width: ${theme.breakpoints.values.sm}px)`]: {
    display: 'none',
  },
}));

export const SongActionsContainer = styled(Box)(() => ({
  marginLeft: 'auto',
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  containerType: 'inline-size',
  height: isMobile ? 64 : 90,
  width: isMobile ? '100%' : undefined,
  borderBottom: `1px solid ${theme.palette.grey[800]}`,
}));

export const PlayerContainer = styled(Box)(() => ({
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const SeekbarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'left',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-end',
  },
}));

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    marginLeft: isMobile ? theme.spacing(1) : 0,
    flexDirection: isMobile ? 'column' : 'row',
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 500,
    marginLeft: isMobile ? 0 : theme.spacing(2),
    marginRight: isMobile ? 0 : theme.spacing(1),
    textDecoration: 'none',
  },
  newSongButton: {
    marginLeft: theme.spacing(1),
    height: 16,
    fontSize: '0.625rem',
    '& .MuiChip-label': {
      padding: theme.spacing(1),
    },
  },
  micIcon: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('xl')]: {
      fontSize: '1.25rem',
      marginRight: theme.spacing(0.5),
      display: 'none',
    },
    color: theme.palette.grey[400],
  },
}));

export default useStyles;
